module.exports = __webpack_public_path__ + "img/3x.567e71cc.jpg";